import { useUserInfor } from "../../../../Context/User";
import { get, off, onValue } from "firebase/database";
import { useCallback, useEffect, useState } from "react";
import { useAtedimento } from "../../../../Context/Atendimento";
import {
    IChat,
    IChatComStatus,
} from "../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import {
    faArrowsAltV,
    faCheckCircle,
    faCircle,
    faClock,
    faComment,
    faCommentDots,
    faExchangeAlt,
    faEye,
    faInfoCircle,
    faPhone,
    faUser,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../Components/Table";
import {
    formatMessageTimeStamp,
    formatPhone,
    fullFormatPhone,
} from "../../../../Tools/FormatTools";
import { ListarEquipesController } from "../../../../Controllers/HelpDesk/Equipes/EquipesControllers";
import {
    IEquipe,
    IEquipeGerencia,
    IUsuarioFirebase,
} from "../../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { UsuarioInterface } from "../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import "./styles.css";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import Transferir from "../../Atendimento/Conversa/Transferir";
import ModalAtendimentoAberto from "./ModalAtendimentoAberto";
import Swal from "sweetalert2";
import { FinalizarAtendimentoController } from "../../../../Controllers/HelpDesk/Atendimento/AtendimentoControllers";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import Cronometro from "../../../../Components/Time/Cronometro";
import {
    getChatsRef,
    getConversaRef,
    getOnlineRef,
} from "../../../../Services/Config/ConfigFirebase";
import { ListarEquipesGerenciaController } from "../../../../Controllers/HelpDesk/Equipes/EquipesGerenciaController";
import LeiaMais from "../../../../Components/Utils/LeiaMais";
import FiltroAtendimentosEmAberto from "../FiltroAtendimentosEmAberto";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import { useMemo } from "react";
import { FiltrarEmpreendimentoFilaController } from "../../../../Controllers/HelpDesk/GestaoAtendimentos/GestaoAtendimentosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";

export interface IFiltroAtendimentosAbertos {
    FL_STATUS: boolean;
    FL_FILA_ATENDIMENTO: boolean;
    idUsuario: number;
    ID_EQUIPE_HELP_DESK: number;
    ID_EMPREENDIMENTO: number[];
    tempoAbertoMin?: number;
    tempoAbertoMax?: number;
    tempoAbertoUnity?: "minutos" | "horas" | "dias";
    tempoEsperandoClienteMin?: number;
    tempoEsperandoClienteMax?: number;
    tempoEsperandoClienteUnity?: "minutos" | "horas" | "dias";
    tempoClienteAguardandoMin?: number;
    tempoClienteAguardandoMax?: number;
    tempoClienteAguardandoUnity?: "minutos" | "horas" | "dias";
}
type TOrderByAttribute = "lastIteractionTime" | "clientPhone";
type TOrderByType = "DESC" | "ASC";
type TOrderByCompleteConfig = `${TOrderByAttribute}_${TOrderByType}`;
const orderOptions: Array<{
    orderby: TOrderByCompleteConfig;
    title: string;
}> = [
    {
        orderby: "lastIteractionTime_ASC",
        title: "Interações mais recentes primeiro",
    },
    {
        orderby: "lastIteractionTime_DESC",
        title: "Interações mais antigas primeiro",
    },
    {
        orderby: "clientPhone_ASC",
        title: "Telefone do cliente - crescente",
    },
    {
        orderby: "clientPhone_DESC",
        title: "Telefone do cliente - decrescente",
    },
];
function getTimeStampFrom(
    atendimento: IChatComStatus,
    from: "client" | "attendant"
) {
    let tempoDaUltimaMensagemRelevante = 0;
    if (from === "client") {
        tempoDaUltimaMensagemRelevante =
            atendimento.conversa?.[
                atendimento.conversa?.length - atendimento.Lido
            ]?.TimeStamp || Date.now();
        return tempoDaUltimaMensagemRelevante;
    } else {
        if (atendimento.Lido > 0) {
            tempoDaUltimaMensagemRelevante = 0;
        } else {
            const ultimaMensagemDoClienteIndex = Array.from(
                atendimento.conversa ?? []
            )
                .reverse()
                .findIndex((mensagem) => mensagem.MensagemCliente);
            tempoDaUltimaMensagemRelevante =
                atendimento.conversa?.[
                    atendimento.conversa.length - ultimaMensagemDoClienteIndex
                ]?.TimeStamp ?? Date.now();
        }
    }
    return tempoDaUltimaMensagemRelevante;
}
function convertTimestampToUnityFromNow(
    timestamp: number | undefined,
    unity: "minutos" | "horas" | "dias"
) {
    if (!timestamp) return 0;
    const timeFromNowInMiliSeconds = Date.now() - timestamp;
    if (unity === "minutos") return timeFromNowInMiliSeconds / 1000 / 60;
    else if (unity === "horas")
        return timeFromNowInMiliSeconds / 1000 / 60 / 60;
    else return timeFromNowInMiliSeconds / 1000 / 60 / 60 / 24;
}
function filterTimestampPeriod(
    min: number | undefined,
    max: number | undefined,
    unity: "minutos" | "horas" | "dias" | undefined,
    value: number | undefined,
    from?: "client" | "attendant"
) {
    const timeFromNow = convertTimestampToUnityFromNow(
        value,
        unity ?? "minutos"
    );
    let approvedInFilter = true;
    if (min && !isNaN(min)) {
        approvedInFilter = timeFromNow >= min;
    }
    if (max && !isNaN(max)) {
        approvedInFilter = approvedInFilter && timeFromNow <= max;
    }
    if (from && ((min && !isNaN(min)) || (max && !isNaN(max)))) {
        approvedInFilter = approvedInFilter && timeFromNow !== 0;
    }
    return approvedInFilter;
}
export default function AtendimentosAbertos() {
    const [loading, setLoading] = useState(true);
    const { equipe } = useAtedimento().HELP_DESK;
    const { OrgInfor } = useUserInfor();
    const { PageFilter, filter, setPageFilter, setPage } =
        usePaginationFilter<IFiltroAtendimentosAbertos>({
            page: 1,
        });
    const [orderedBy, setOrderedBy] = useState<TOrderByCompleteConfig>(
        "lastIteractionTime_ASC"
    );
    const [lstAtendimentoemAberto, setlstAtendimentoemAberto] = useState<
        Array<IChatComStatus>
    >([]);
    const {
        execute: filtrarEmpreendimentoFila,
        loading: filtrarEmpreendimentoFilaLoading,
    } = useAsyncCallback(
        (idEmpreendimento: number[], FL_FILA_ATENDIMENTO: boolean) =>
            FiltrarEmpreendimentoFilaController(
                idEmpreendimento,
                FL_FILA_ATENDIMENTO
            )
    );
    const [lstAtendimentoAbertosFiltrados, setLstAtendimentoAbertosFiltrados] =
        useState<Array<IChatComStatus>>(lstAtendimentoemAberto);
    const [numCliente, setNumClientes] = useState<Array<string>>([]);
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [lstEquipes, setLstEquipes] = useState<Array<IEquipe>>();
    const [lstUsuarios, setlstUsuarios] = useState(
        [] as Array<UsuarioInterface>
    );
    const [lstEquipeGerencia, setlstEquipeGerencia] = useState(
        [] as Array<IEquipeGerencia>
    );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [idEmpreendimento, setIdEmpreendimento] = useState<number[]>([]);
    const [usuariosOn, setUsuariosOn] = useState<Array<number>>([]); // array com o id de quem está online
    const FILTRO_GESTAO_ACORDOS_COBRANCA = sessionStorage.getItem(
        "FILTRO_GESTAO_REPASSE"
    );
    const lstAtendimentoemAbertoOrdered = useMemo(() => {
        const [attribute, type] = orderedBy.split("_");
        const orderdArray = Array.from(lstAtendimentoAbertosFiltrados).sort(
            (a, b) => {
                if (attribute === "lastIteractionTime")
                    return b.TimeStamp - a.TimeStamp;
                else return a.NumeroCliente.localeCompare(b.NumeroCliente);
            }
        );
        if (type === "DESC") orderdArray.reverse();
        return orderdArray;
    }, [orderedBy, lstAtendimentoAbertosFiltrados]);
    const defaultFilter = FILTRO_GESTAO_ACORDOS_COBRANCA
        ? JSON.parse(FILTRO_GESTAO_ACORDOS_COBRANCA)
        : filter;
    useEffect(() => {
        updateList();
    }, []);

    const lstAtendimentoFilter =
        filter?.ID_EMPREENDIMENTO && filter?.ID_EMPREENDIMENTO.length > 0
            ? lstAtendimentoemAbertoOrdered.filter((res) => {
                  return numCliente?.includes(res.NumeroCliente);
              })
            : lstAtendimentoemAbertoOrdered;

    const handleFilter = useCallback(() => {
        if (
            filter?.idUsuario ||
            filter?.FL_STATUS ||
            filter?.ID_EQUIPE_HELP_DESK ||
            filter?.tempoAbertoMin ||
            filter?.tempoAbertoMax ||
            filter?.tempoClienteAguardandoMin ||
            filter?.tempoClienteAguardandoMax ||
            filter?.tempoEsperandoClienteMin ||
            filter?.tempoEsperandoClienteMax ||
            filter?.ID_EMPREENDIMENTO
        ) {
            filtrarEmpreendimentoFila(
                idEmpreendimento,
                filter?.FL_FILA_ATENDIMENTO ?? false
            )
                .then((numCliente) => {
                    setNumClientes(numCliente);
                    if (numCliente.length > 0) {
                        const filtradoPorCliente =
                            lstAtendimentoAbertosFiltrados.filter(
                                (atendimento) =>
                                    numCliente.includes(
                                        atendimento.NumeroCliente
                                    )
                            );
                        setLstAtendimentoAbertosFiltrados(filtradoPorCliente);
                    }
                })
                .finally(() => {
                    setLstAtendimentoAbertosFiltrados(
                        lstAtendimentoemAberto.filter(
                            (atendimento) =>
                                (!Number(filter?.ID_EQUIPE_HELP_DESK) ||
                                    atendimento.IDEquipe ===
                                        Number(filter?.ID_EQUIPE_HELP_DESK)) &&
                                (filter?.FL_STATUS === undefined ||
                                    atendimento.atendenteOnline ===
                                        filter?.FL_STATUS) &&
                                (!filter?.idUsuario ||
                                    atendimento.IdUsuario ===
                                        Number(filter?.idUsuario)) &&
                                filterTimestampPeriod(
                                    filter?.tempoAbertoMin,
                                    filter?.tempoAbertoMax,
                                    filter?.tempoAbertoUnity,
                                    atendimento?.conversa?.[0]?.TimeStamp
                                ) &&
                                filterTimestampPeriod(
                                    filter?.tempoClienteAguardandoMin,
                                    filter?.tempoClienteAguardandoMax,
                                    filter?.tempoClienteAguardandoUnity,
                                    getTimeStampFrom(atendimento, "client"),
                                    "client"
                                ) &&
                                filterTimestampPeriod(
                                    filter?.tempoEsperandoClienteMin,
                                    filter?.tempoEsperandoClienteMax,
                                    filter?.tempoEsperandoClienteUnity,
                                    getTimeStampFrom(atendimento, "attendant"),
                                    "attendant"
                                )
                        )
                    );
                });
        } else {
            setLstAtendimentoAbertosFiltrados(lstAtendimentoemAberto);
            if (idEmpreendimento.length > 0) {
                filtrarEmpreendimentoFila(
                    idEmpreendimento,
                    filter?.FL_FILA_ATENDIMENTO ?? false
                ).then((numCliente) => {
                    setNumClientes(numCliente);
                    if (numCliente.length > 0) {
                        const filtradoPorCliente =
                            lstAtendimentoAbertosFiltrados.filter(
                                (atendimento) =>
                                    numCliente.includes(
                                        atendimento.NumeroCliente
                                    )
                            );
                        setLstAtendimentoAbertosFiltrados(filtradoPorCliente);
                    }
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, lstAtendimentoemAberto]);

    useEffect(() => {
        return handleFilter();
    }, [handleFilter, PageFilter]);
    async function updateList() {
        setLoading(true);
        await ListarEquipesController().then((res) => {
            setLstEquipes(res);
        });
        await ListarUsuariosController()
            .then((res) => res.filter((u) => u.FL_ATIVO))
            .then((response) => {
                setlstUsuarios(response);
            });
        await ListarEquipesGerenciaController().then((response) => {
            setlstEquipeGerencia(response);
        });
        setLoading(false);
    }
    useEffect(() => {
        if (equipe?.NR_TELEFONE) {
            const equipesRef = getOnlineRef(OrgInfor.ID_ORGANIZACAO);
            onValue(equipesRef, (snap) => {
                const usuariosOn: Array<number> = [];
                snap.forEach((equipeSnap) => {
                    const lstUsuarios = equipeSnap.val().USUARIOS
                        ? Object.entries<IUsuarioFirebase>(
                              equipeSnap.val().USUARIOS
                          ).map((entry) => entry[1])
                        : [];
                    lstUsuarios.forEach((usuario) => {
                        usuariosOn.push(usuario.ID_USUARIO);
                    });
                });
                setUsuariosOn(usuariosOn);
            });
        }
        return function cleanup() {
            if (equipe?.NR_TELEFONE) off(getOnlineRef(OrgInfor.ID_ORGANIZACAO));
        };
    }, [OrgInfor.ID_ORGANIZACAO, equipe?.NR_TELEFONE]);
    const atualizarAtendimentos = useCallback(
        (lstEquipeGerencia: Array<IEquipe>) => {
            const chats: Array<IChatComStatus> = [];
            lstEquipeGerencia.forEach((equipe) => {
                if (equipe?.NR_TELEFONE) {
                    const chatRef = getChatsRef(
                        OrgInfor.ID_ORGANIZACAO,
                        equipe?.NR_TELEFONE
                    );
                    onValue(
                        chatRef,
                        async (snap) => {
                            snap.forEach((childSnap) => {
                                const chat: IChat = childSnap.val();
                                if (
                                    chat.IDEquipe === equipe.ID_EQUIPE_HELP_DESK
                                )
                                    chats.push({
                                        ...chat,
                                        atendenteOnline: !!usuariosOn.find(
                                            (userId) =>
                                                chat.IdUsuario === userId
                                        ),
                                    });
                            });
                            Promise.all(
                                chats.map(async (chat) => {
                                    chat.conversa = [];
                                    const conversaRef = getConversaRef(
                                        OrgInfor.ID_ORGANIZACAO,
                                        equipe?.NR_TELEFONE,
                                        chat.NumeroCliente
                                    );
                                    await get(conversaRef).then(
                                        (conversaSnap) => {
                                            conversaSnap.forEach((mensagem) => {
                                                chat.conversa?.push(
                                                    mensagem.val()
                                                );
                                            });
                                        }
                                    );
                                })
                            ).then(() => {
                                setlstAtendimentoemAberto(chats);
                            });
                        },
                        { onlyOnce: true }
                    );
                }
            });
        },
        [OrgInfor.ID_ORGANIZACAO, usuariosOn]
    );
    useEffect(() => {
        atualizarAtendimentos(lstEquipeGerencia);
    }, [
        OrgInfor.ID_ORGANIZACAO,
        usuariosOn,
        equipe?.NR_TELEFONE,
        lstEquipeGerencia,
        atualizarAtendimentos,
    ]);
    const atendimentoColumns: Array<ColumnDescription> = [
        {
            dataField: "NumeroCliente",
            text: "",
            formatter: atendimentoRow,
        },
        {
            dataField: "",
            text: "",
            hidden: true,
        },
        { dataField: "NomeUsuario", text: "", hidden: true },
    ];
    function atendimentoRow(cell: any, row: IChatComStatus) {
        const atendimento = row;
        const Equipe = lstEquipes?.find(
            (x) => x.ID_EQUIPE_HELP_DESK === atendimento.IDEquipe
        );
        const Usuario = lstUsuarios?.find(
            (x) => x.ID_USUARIO === atendimento.IdUsuario
        );
        const primeiraMensagem = atendimento.conversa
            ? atendimento.conversa[0]
            : null;
        const ultimaMensagem = atendimento.conversa
            ? atendimento.conversa[atendimento.conversa.length - 1]
            : null;
        const tempoTotalAtendimento =
            Date.now() - (primeiraMensagem?.TimeStamp || Date.now());
        const tempoSemResposta =
            Date.now() -
            (atendimento.conversa?.[
                atendimento.conversa?.length - atendimento.Lido
            ]?.TimeStamp || Date.now());
        return (
            <>
                <div key={atendimento.NumeroCliente}>
                    <div className="card card-custom m-2">
                        <div className="card-header ribbon ribbon-top ribbon-ver ">
                            <div className="card-title mt-17">
                                <div>
                                    {atendimento.NomeCliente ? (
                                        <>
                                            <h3 className="card-label">
                                                {atendimento.NomeCliente}{" "}
                                                <small>
                                                    {
                                                        atendimento.NomeContatoCliente
                                                    }
                                                </small>
                                            </h3>
                                        </>
                                    ) : (
                                        <>
                                            <h3 className="card-label">
                                                Sem Contato Vinculado{" "}
                                                <small>
                                                    {" "}
                                                    Sem Contato Vinculado
                                                </small>
                                            </h3>
                                        </>
                                    )}
                                    <div>
                                        <span className="label label-light-dark label-inline mr-2 my-1">
                                            <FontAwesomeIcon
                                                icon={faPhone}
                                                className="mr-1"
                                            />
                                            {fullFormatPhone(
                                                atendimento.NumeroCliente
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="ribbon-target-mult d-none d-sm-flex">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            Tempo total do atendimento
                                        </Tooltip>
                                    }
                                >
                                    <div
                                        className="ribbon-target bg-dark ribbonCustom mr-1"
                                        style={{ top: "-2px" }}
                                    >
                                        <Cronometro
                                            TimeStamp={tempoTotalAtendimento}
                                        />
                                    </div>
                                </OverlayTrigger>
                                {atendimento.Lido > 0 && (
                                    <>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="tooltip-disabled">
                                                    Tempo aguardando resposta
                                                </Tooltip>
                                            }
                                        >
                                            <div
                                                className="ribbon-target bg-info ribbonCustom mr-1"
                                                style={{ top: "-2px" }}
                                            >
                                                {/** Correção provisória - Isso está sendo feito pra não ficar horas negativas por causa do bug de horário negativo */}
                                                <Cronometro
                                                    TimeStamp={
                                                        tempoSemResposta >= 0
                                                            ? tempoSemResposta
                                                            : tempoSemResposta +
                                                              60 * 60 * 1000
                                                    }
                                                />
                                            </div>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="tooltip-disabled">
                                                    Mensagens não respondidas
                                                </Tooltip>
                                            }
                                        >
                                            <div
                                                className="ribbon-target bg-warning ribbonCustom mr-1"
                                                style={{ top: "-2px" }}
                                            >
                                                {atendimento.Lido}
                                            </div>
                                        </OverlayTrigger>
                                    </>
                                )}
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {atendimento.atendenteOnline
                                                ? "Online"
                                                : "Offline"}
                                        </Tooltip>
                                    }
                                >
                                    <div
                                        className={`ribbon-target bg-${
                                            atendimento.atendenteOnline
                                                ? "success"
                                                : "danger"
                                        } ribbonCustom mr-1`}
                                        style={{ top: "-2px" }}
                                    >
                                        {Usuario?.DS_NOME ? (
                                            <>
                                                <FontAwesomeIcon
                                                    icon={faUser}
                                                    className="mr-1"
                                                />
                                                {Usuario?.DS_NOME}{" "}
                                            </>
                                        ) : (
                                            <>
                                                <FontAwesomeIcon
                                                    icon={faUser}
                                                    className="mr-1"
                                                />{" "}
                                                Fila de Atendimento{" "}
                                            </>
                                        )}
                                    </div>
                                </OverlayTrigger>
                                <div
                                    className="ribbon-target bg-primary ribbonCustom mr-1"
                                    style={{ top: "-2px" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faUsers}
                                        className="mr-1"
                                    />
                                    {Equipe?.DS_EQUIPE_HELP_DESK}
                                </div>
                            </div>
                            <OverlayTrigger
                                overlay={
                                    <Tooltip
                                        id="tooltip-disabled"
                                        className="d-flex flex-column"
                                    >
                                        <div className="d-flex flex-column font-size font-weight-bold">
                                            {atendimento.Lido > 0 && (
                                                <>
                                                    <div>
                                                        <FontAwesomeIcon
                                                            icon={faClock}
                                                            className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                                        />
                                                        Sem Resposta:{" "}
                                                        <Cronometro
                                                            TimeStamp={
                                                                tempoSemResposta
                                                            }
                                                        />
                                                    </div>
                                                    <div>
                                                        <FontAwesomeIcon
                                                            icon={faComment}
                                                            className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                                        />
                                                        Não Respondidas:{" "}
                                                        {atendimento.Lido}
                                                    </div>
                                                </>
                                            )}
                                            <div>
                                                <FontAwesomeIcon
                                                    icon={faCircle}
                                                    className={`svg-icon svg-icon-md svg-icon-gray-500 mr-1 text-${
                                                        !Usuario?.DS_NOME
                                                            ? "primary"
                                                            : atendimento.atendenteOnline
                                                            ? "success"
                                                            : "danger"
                                                    }`}
                                                />
                                                {Usuario?.DS_NOME ??
                                                    "Fila de Atendimento"}
                                            </div>
                                        </div>
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="d-flex d-sm-none position-absolute text-primary"
                                    style={{ right: "10px", top: "10px" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        size="2x"
                                        className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                    />
                                </div>
                            </OverlayTrigger>
                        </div>
                        <div className="card-body padding-1x">
                            <div className="d-flex flex-wrap align-items-center justify-content-between">
                                <div className="d-flex  flex-wrap flex-column">
                                    <div className="mr-12 d-flex flex-column">
                                        <span className="text-muted font-size-sm mr-2">
                                            Primeira Mensagem{" "}
                                            {atendimento
                                                ? formatMessageTimeStamp(
                                                      primeiraMensagem?.TimeStamp ||
                                                          atendimento?.TimeStamp,
                                                      true,
                                                      primeiraMensagem?.TimeStampSync
                                                  ) + ". "
                                                : " "}
                                        </span>
                                        <span className="text-muted  font-bold mr-5 text-break">
                                            Ultima Mensagem{" "}
                                            {atendimento
                                                ? formatMessageTimeStamp(
                                                      atendimento?.TimeStamp,
                                                      true,
                                                      ultimaMensagem?.TimeStampSync
                                                  ) + " "
                                                : " "}
                                            <LeiaMais charLimit={100}>
                                                {atendimento.UltimaMensagem}
                                            </LeiaMais>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="d-flex flex-wrap g-2 w-100">
                                <button
                                    className="btn d-flex align-items-center justify-content-center g-2 btn-outline-primary mt-1 flex-grow-1"
                                    onClick={() => {
                                        setModal({
                                            Component: () =>
                                                Transferir({
                                                    setShow,
                                                    transferenciaPorGestao: {
                                                        From: atendimento.NumeroAtendente,
                                                        To: atendimento.NumeroCliente,
                                                        ID_EQUIPE:
                                                            atendimento.IDEquipe,
                                                        ID_USUARIO:
                                                            atendimento.IdUsuario,
                                                    },
                                                }),
                                            headerComponent: "Transferir",
                                            IconHeader: faExchangeAlt,
                                        });
                                        setShow(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faExchangeAlt} />
                                    Tranferir
                                </button>
                                <button
                                    className="btn d-flex align-items-center justify-content-center g-2 btn-outline-success mt-1 flex-grow-1"
                                    onClick={() => {
                                        Swal.fire({
                                            title: "Finalizar Atendimento?",
                                            icon: "success",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                FinalizarAtendimentoController(
                                                    formatPhone(
                                                        atendimento.NumeroCliente
                                                    )
                                                );
                                            }
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                    Finalizar
                                </button>
                                <button
                                    className="btn d-flex align-items-center justify-content-center g-2 btn-outline-info mt-1 flex-grow-1"
                                    onClick={() => {
                                        setModal({
                                            Component: () => (
                                                <ModalAtendimentoAberto
                                                    chat={
                                                        atendimento.NumeroAtendente
                                                    }
                                                    nrTelefone={
                                                        atendimento.NumeroCliente
                                                    }
                                                />
                                            ),
                                            headerComponent: "Atendimento",
                                            IconHeader: faCommentDots,
                                            size: "lg",
                                            customBodyClasses:
                                                "customScroll modal-controlled-heigth",
                                        });
                                        setShow(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                    Acompanhar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    const handleOrderButtonClickFactory = (orderBy: TOrderByCompleteConfig) => {
        return function () {
            setOrderedBy(orderBy);
            if (orderBy !== orderedBy) setPage(1);
        };
    };
    return (
        <>
            <FiltroAtendimentosEmAberto
                defaultFilter={defaultFilter}
                setIdEmpreendimento={setIdEmpreendimento}
                handleSubmit={(formData) => {
                    setPageFilter({
                        filter: {
                            idUsuario: formData.idUsuario,
                            ID_EQUIPE_HELP_DESK: formData.ID_EQUIPE_HELP_DESK,
                            FL_STATUS: formData.FL_STATUS,
                            FL_FILA_ATENDIMENTO: formData.FL_FILA_ATENDIMENTO,
                            tempoAbertoMax: formData.tempoAbertoMax,
                            tempoAbertoMin: formData.tempoAbertoMin,
                            tempoAbertoUnity: formData.tempoAbertoUnity,
                            tempoClienteAguardandoMax:
                                formData.tempoClienteAguardandoMax,
                            tempoClienteAguardandoMin:
                                formData.tempoClienteAguardandoMin,
                            tempoClienteAguardandoUnity:
                                formData.tempoClienteAguardandoUnity,
                            tempoEsperandoClienteMax:
                                formData.tempoEsperandoClienteMax,
                            tempoEsperandoClienteMin:
                                formData.tempoEsperandoClienteMin,
                            tempoEsperandoClienteUnity:
                                formData.tempoEsperandoClienteUnity,
                            ID_EMPREENDIMENTO: idEmpreendimento,
                        },
                        page: 1,
                    });
                }}
                // storageManager={filterStorage}
            />
            <div className="d-flex justify-content-end w-100 my-2">
                <button
                    className="btn btn-outline-primary mr-5"
                    onClick={() => atualizarAtendimentos(lstEquipeGerencia)}
                >
                    Atualizar Atendimentos
                </button>
                <Dropdown>
                    <Dropdown.Toggle
                        id="order-by-dropdown"
                        className="d-flex align-items-center g-2"
                    >
                        <FontAwesomeIcon icon={faArrowsAltV} />
                        Ordenar
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {orderOptions.map((orderOption) => (
                            <Dropdown.Item
                                onClick={handleOrderButtonClickFactory(
                                    orderOption.orderby
                                )}
                                active={orderOption.orderby === orderedBy}
                            >
                                {orderOption.title}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <Table
                columns={atendimentoColumns}
                data={lstAtendimentoFilter}
                keyField="NumeroCliente"
                loading={loading || filtrarEmpreendimentoFilaLoading}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Atendimento encontrado
                    </div>
                )}
                noHover
                bordered={false}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
